import { createUseStyles } from "react-jss";
import { ITheme } from "../../types/theme";

export const TOTAL_PROGRESS = 116;
const DIMENSION = {
  circle: {
    small: {
      width: 48,
      height: 48,
    },
    medium: {
      width: 72,
      height: 72,
    },
    large: {
      width: 96,
      height: 96,
    },
    extraLarge: {
      width: 120,
      height: 120,
    },
  },
  linear: {
    small: {
      height: 8,
    },
    medium: {
      height: 12,
    },
    large: {
      height: 16,
    },
    extraLarge: {
      height: 50,
    },
  },
};

const getInitialValue = (initial: number) =>
  initial >= 100 ? TOTAL_PROGRESS : (TOTAL_PROGRESS / 100) * initial;

const getTargetValue = (target: number) =>
  target >= 100 ? TOTAL_PROGRESS : (TOTAL_PROGRESS / 100) * target;

export const useStyles = (initial: number, target: number, timing?: number) => {
  const initialValue = getInitialValue(initial);
  const targetValue = getTargetValue(target);

  return createUseStyles((theme: ITheme) => ({
    root: {
      ...DIMENSION.linear.large,
      padding: theme.spacing.space2,
      position: "relative",
      boxSizing: "border-box",
      background: theme.colors.background,
      width: "100%",
      borderRadius: theme.radius.large,
      "&.small": {
        ...DIMENSION.linear.small,
        padding: theme.spacing.space2 - 1,
        "& $bar": {
          boxShadow: `inset 0 0 0 1px ${theme.colors.border1}`,
          padding: theme.spacing.space2 - 1,
        },
      },
      "&.medium": {
        ...DIMENSION.linear.medium,
        padding: theme.spacing.space2 - 1,
        "& $bar": {
          boxShadow: `inset 0 0 0 1px ${theme.colors.border1}`,
          padding: theme.spacing.space2 - 1,
        },
      },
      "&.large": {
        ...DIMENSION.linear.large,
        padding: theme.spacing.space2,
      },
      "&.extraLarge": {
        ...DIMENSION.linear.extraLarge,
        padding: theme.spacing.space2,
        borderRadius: theme.radius.medium,
        "& $bar": {
          borderRadius: theme.radius.medium,
          boxShadow: `none`,
        },
      },
      "&.bg-primary": {
        background: theme.colors.border1,
      },
    },
    bar: {
      minWidth: "min-content",
      height: "100%",
      borderRadius: theme.radius.large,
      boxShadow: `inset 0 0 0 2px ${theme.colors.border1}`,
      boxSizing: "border-box",
      transition: "width 1s",
    },
    oProgressCircle: {
      display: "inlineBlock",
      position: "relative",
      ...DIMENSION.circle.small,
      "&.small": { ...DIMENSION.circle.small },
      "&.medium": { ...DIMENSION.circle.medium },
      "&.large": { ...DIMENSION.circle.large },
      "&.extraLarge": { ...DIMENSION.circle.extraLarge },
    },
    circleBackground: {
      stroke: theme.colors.border1,
    },
    circleG: {
      fill: "none",
    },
    text: {
      display: "flex",
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: "100%",
      justifyContent: "center",
    },
    circleMain: {
      strokeLinecap: "round",
      animation: `$loadCircle forwards ${timing}ms`,
      stroke: theme.colors.primary,
      strokeDasharray: TOTAL_PROGRESS,
      "&.disabled": {
        animation: "none",
      },
    },
    "@keyframes loadCircle": {
      "0%": {
        strokeDashoffset: TOTAL_PROGRESS - initialValue,
      },
      "100%": {
        strokeDashoffset: TOTAL_PROGRESS - targetValue,
      },
    },
  }))();
};
